import axios from "../../axios/interceptor.js";
import Toast from "../../component/toastify/Index";

export const getKostenplanungLists = async (payload) => {
    try {
        const response = await axios.post('/customer/umsatzplanung/kostenplanung/get', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const loadVerbindlichkeitenOptions = async (clientId) => {
    try {
        const response = clientId ? await axios.get(`/customer/verbindlichkeiten/options?clientId=${clientId}`) : await axios.get('/customer/verbindlichkeiten/options')
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const getByIdKostenplanung = async (id, clientId) => {
    try {
        const response = clientId ? await axios.get(`/customer/umsatzplanung/kostenplanung/get/${id}?clientId=${clientId}`) : await axios.get(`/customer/umsatzplanung/kostenplanung/get/${id}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const deleteKostenplanung = async (id, clientId) => {
    try {
        const response = clientId ? await axios.put(`/customer/umsatzplanung/kostenplanung/delete/${id}?clientId=${clientId}`) : await axios.put(`/customer/umsatzplanung/kostenplanung/delete/${id}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


export const createKostenplanung = async (payload) => {
    try {
        const response = await axios.post('/customer/umsatzplanung/kostenplanung/create', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


export const updateKostenplanung = async (payload) => {
    try {
        const response = await axios.put('/customer/umsatzplanung/kostenplanung/update', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}